var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page-data-management",attrs:{"id":"data-management"}},[_c('module-header'),_c('div',{staticClass:"page-content p-3",attrs:{"id":"pageContent"}},[_c('content-spinner',{attrs:{"show":_vm.isLoading}}),_c('folders-list')],1),(_vm.folderModal.show)?_c('folder-modal',{on:{"on-folder-save":_vm.prepareData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }